import { useEffect, useState } from "react";
import Table from "../../../components/common/table/Table";
import Title from "../../../components/common/title/Title";
import { getApi } from "../../../services/api/globalApi";
import { digitsThree } from "../../../utils/price";
import UserReportsFilter from "./UserReportsFilter";
import ExportExcel from "../../../components/common/export-exel/ExportExel";
import { utilsState } from "../../../sotre/redux/features/utilsSlice";
import { useSelector } from "react-redux";
import * as XLSX from "xlsx";
import { convertDate } from "../../../utils/convertDate";
import moment from "jalali-moment";
import { usersReportsColumns } from "../../../constant/tablesColumns/tablesColums";
import { errorMessage } from "../../../utils/toastify-message/ToastifyMessage";

export default function UsersReports() {
  const [userReportsData, setUsersReportsData] = useState([]);
  const { utils } = useSelector(utilsState);
  const [activeSearchButton, setActiveSearchButton] = useState(true);

  const getProductReports = async (params) => {
    const path = "admin/reports/usersTotalSales";
    try {
      setActiveSearchButton(false);
      const response = await getApi({ path, params: { ...params } });
      setUsersReportsData(response?.data?.result);
      setActiveSearchButton(true);
    } catch (error) {
      console.log(error);
    }
  };

  const filterDataHandler = (newParams) => {
    getProductReports(newParams);
  };

  const data = [];

  userReportsData?.map((item) =>
    data.push({
      ...item,
      refFinalPriceSum: digitsThree(item.refFinalPriceSum),
      finalPriceSum: digitsThree(item.finalPriceSum),
      _ref_user_old_totalProductsPrice: digitsThree(
        item._ref_user_old_totalProductsPrice
      ),
      old_totalProductsPriceSum: digitsThree(item.old_totalProductsPriceSum),
      old_refTotalProductsPriceSum: digitsThree(
        item.old_refTotalProductsPriceSum
      ),
      totalPrice: digitsThree(item.totalPrice),
      name: item?.name,
      mobile: item?.mobile,
      role: utils?.ROLES[item?.role]?.name || "",
      id: item._id,
      ordersCount: item?.ordersData?.length,
    })
  );

  const exportReportsData = [];

  userReportsData?.map((item) =>
    exportReportsData.push({
      نام: item?.name,
      موبایل: item?.mobile,
      نقش: utils.ROLES[item?.role]?.name || "",
      "ناخالص خرید شخصی محصولات (قیمت قدیم)": item?.old_totalProductsPriceSum,
      "ناخالص خرید لینک ارجاع محصولات (قیمت قدیم)":
        item?.old_refTotalProductsPriceSum,
      "مجموع نا خالص (قیمت قدیم)": item?._ref_user_old_totalProductsPrice,
      "مجموع پرداختی شخصی": item?.finalPriceSum,
      "مجموع پرداختی لینک ارجاع": item?.refFinalPriceSum,
      "تعداد سفارش": item.ordersData?.length || item?.ordersCount,
    })
  );

  const handleDataForPrint = (exportData) => {
    const newData = exportData.map((item) => {
      return {
        "شماره سفارش": item.trackingCode,
        "تاریخ پرداخت": convertDate(item?.paymentDate || item?.createdAt),
        "مبلغ پرداختی": item?.finalPrice,
        "مجموع ناخالص محصول ": item?.totalProductsPrice,
        "مجموع خالص محصول": item?.finalProductsPrice,
        "مجموع ناخالص": item?.totalPrice,
        "هزینه حمل و نقل": item?.shippingFinalPrice,
        "تخفیف کل": item?.totalDiscount,
        "لینک ارجاع": item?.ref ? "بله" : "خیر",
        "تعداد سفارش": item.ordersData?.length || item?.ordersCount,
      };
    });
    return newData;
  };

  const hadnleExel = (data) => {
    const newRefData = data?.refOrders?.map((item) => {
      return { ...item, ref: true };
    });

    const exportData = [...newRefData, ...data?.ordersData];

    const newExportData = handleDataForPrint(exportData);

    const workbook = XLSX.utils.book_new();
    const worksheet = XLSX.utils.json_to_sheet(newExportData);
    XLSX.utils.book_append_sheet(workbook, worksheet, "Data");
    XLSX.writeFile(workbook, "exported_data.xlsx");
  };

  return (
    <div className="bg-white dark:bg-gray-900 rounded-3xl p-6">
      <div className="flex flex-col sm:flex-row justify-betwseen items-center">
        <Title title={"گزارش کاربران"} />
        <div className="w-full mt-4 sm:mt-0 flex justify-end">
          <ExportExcel jsonData={exportReportsData} />
        </div>
      </div>
      <div
        className="flex items-center p-4 mb-6 text-sm text-blue-800 border border-blue-300 rounded-lg bg-blue-50 dark:bg-gray-800 dark:text-blue-400 dark:border-blue-800"
        role="alert"
      >
        <svg
          className="flex-shrink-0 inline w-4 h-4 me-3"
          aria-hidden="true"
          xmlns="http://www.w3.org/2000/svg"
          fill="currentColor"
          viewBox="0 0 20 20"
        >
          <path d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5ZM9.5 4a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3ZM12 15H8a1 1 0 0 1 0-2h1v-3H8a1 1 0 0 1 0-2h2a1 1 0 0 1 1 1v4h1a1 1 0 0 1 0 2Z" />
        </svg>
        <span className="sr-only">Info</span>
        <div>
          <span className="font-medium">توجه! </span>
          نقش مشتری تنها کاربرانی که به صورت مستقیم از سایت ثبت سفارش کرده اند
          را نمایش میدهد نه از طریق لینک نماینده یا لینک مشاور
        </div>
      </div>
      <UserReportsFilter
        filterDataHandler={filterDataHandler}
        activeSearchButton={activeSearchButton}
      />
      <Table
        columns={usersReportsColumns}
        rows={data}
        bigColumn={true}
        onCustomFunction={hadnleExel}
        customFunctionName={"خروجی اکسل"}
      />
    </div>
  );
}
